import React, {Component} from "react"

import DealListQuery, {DealListVariables, getDealList} from "@irati/deals/apollo/query/DealList"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"
import authentication from "@irati/auth"
import addOrRemoveFromArray from "@irati/utils/addOrRemoveFromArray"
import {Deal, DealStatus} from "@irati/types"
import productSettingsService from "@irati/permissions/services/productSettings"

import DealListItem from "./DealListItem"
import ListWrapper from "./styled/ListWrapper"
import LoadMore from "../../CompanyBenefitsList/LoadMore"

interface Props {
  tagId: string
  onSave: () => void
  ignoreBlacklist?: boolean
}

interface State {
  blacklistedDeals: string[]
  variables: DealListVariables
}

export default class DealList extends Component<Props, State> {
  state: State = {
    blacklistedDeals: [],
    variables: {
      limit: 10,
      statuses: [DealStatus.On],
      ignoreBlacklist: true
    }
  }

  static defaultProps = {
    tagId: null
  }

  componentDidMount() {
    const {tagId} = this.props
    const {variables} = this.state
    const business = authentication.business()
    productSettingsService.get(business.uuid, business.rootTeamId).then((ps) => {
      const blacklistedDeals = ps.perksSettings?.blacklistedPerks || []
      this.setState({
        blacklistedDeals,
        variables: {
          ...variables,
          tags: [tagId]
        }
      })
    })
  }

  handleToggle = (uuid: string) => {
    const newBlacklistedDeals = addOrRemoveFromArray(this.state.blacklistedDeals, uuid)
    const business = authentication.business()
    return productSettingsService
      .updatePerkSettings(business.uuid, business.rootTeamId, {
        blacklistedPerks: newBlacklistedDeals
      })
      .then((ps) => {
        this.props.onSave()
        this.setState({blacklistedDeals: ps.perksSettings?.blacklistedPerks || []})
      })
  }

  isDealBlackListed = (uuid: string) => {
    return !!this.state.blacklistedDeals.find((blacklistedDealUuid: string) => blacklistedDealUuid === uuid)
  }

  handleNewPage = (isVisible: boolean, apollo: ApolloState<any, DealListVariables>) => {
    if (isVisible) {
      const {results, count} = getDealList(apollo)
      const {variables} = this.state
      const resultsLength = results?.length || 0
      if (resultsLength && resultsLength !== count) {
        // has more
        return apollo.nextPage({...variables, offset: resultsLength})
      }
    }
  }

  render() {
    return (
      <ListWrapper>
        <DealListQuery variables={this.state.variables}>
          {(apollo) => {
            const dealsList = getDealList(apollo)
            return (
              <>
                {dealsList.results.map((deal: Deal) => (
                  <DealListItem
                    key={deal.uuid}
                    deal={deal}
                    blacklisted={this.isDealBlackListed(deal.uuid)}
                    handleToggle={this.handleToggle}
                  />
                ))}
                <LoadMore onVisible={(isVisible: boolean) => this.handleNewPage(isVisible, apollo)} />
              </>
            )
          }}
        </DealListQuery>
      </ListWrapper>
    )
  }
}
